import React from "react";

import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import { DatasetDataInfo } from "models/dataset-models";
import { ScadaTagsProps } from "../scadaTypes";
import ScadaTag from "./ScadaTag";

const ScadaTags: React.FC<ScadaTagsProps> = props => {
  const ids = props.elements?.map(e => e.identifier) ?? [];

  const queriesData = useGetRecentData(ids, {
    refTime: props.date?.toISOString(),
    options: {
      refetchInterval: props.date ? 0 : props.refreshRate * 1000,
    },
  });
	
  const dataMap = queriesData?.data
    ? new Map([...queriesData.data.map(q => [q.identifier, q] as [string, DatasetDataInfo])])
    : new Map();

	return (
    <>
      {[...(props.elements ?? [])].map(el => {
        const layer = props.layerOptions.find(g => g.layer === el.layer);
        if (layer && !layer.visible) return null;
        const dataset = dataMap.get(el.identifier);
        return (
          <ScadaTag
            key={`${props.id}-${el.identifier}`}
            model={props}
            scadaId={props.id!}
            x={el.xCoord}
            y={el.yCoord}
            dataset={dataset}
            identifier={el.identifier}
            bgColor={el.bgColor}
            fontSize={el.fontSize}
            refTime={props.date}
            parent={props.parent}
            gridSize={props.gridSize}
            onCoordChange={props.onCoordChange}
          />
        );
      })}
    </>
  );
};

export default ScadaTags;
